import { all, takeLatest } from 'redux-saga/effects';

import { getTagsAction } from '@/redux/actions';

import { getTagsSaga } from './get-tags';

export default function* root(): Generator {
  yield all([takeLatest(getTagsAction.request.type, getTagsSaga)]);
}
